import React, { useState, useEffect } from 'react';
import { CheckboxControl, DialogControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';

const PublishDialog = ({ isActive, closeDialog }) => {
  const { dashboardLib, switchMode, activeDraftWorkspaceSummary } = useDashboardDomainContext();

  const [errorMessage, setErrorMessage] = useState("");
  const [newPublicState, setNewPublicState] = useState(
    dashboardLib?.activeDashboard?.State?.IsPublic ?? false
  );
  const hasTitle = !!dashboardLib?.activeDashboard?.DraftDetails?.Name;
  const isOnPublishedWorkspace = Number(activeDraftWorkspaceSummary?.status ?? 0) === 2;

  const getResultErrorMessage = (result) =>
    result?.DisplayMessage
    || result?.Message?.DisplayMessage
    || result?.Message?.Content
    || result?.DisplayError
    || "There has been an error with publishing this dashboard. Please try again.";

  useEffect(() => {
    if (isActive) {
      setNewPublicState(dashboardLib?.activeDashboard?.State?.IsPublic ?? false);
      setErrorMessage("");
    }
  }, [isActive, dashboardLib?.activeDashboard?.State?.IsPublic]);

  return (
    <DialogControl
      className="dashboard-dialog"
      openDialog={isActive}
      title="Publish Dashboard"
      onOk={async () => {
        try {
          const result = await dashboardLib.publishDashboard(newPublicState);
          if (result?.Success) {
            closeDialog();
            setNewPublicState(result?.dashboard?.State?.IsPublic ?? newPublicState);
            switchMode('view');
            setErrorMessage("");
            return result;
          }

          setErrorMessage(getResultErrorMessage(result));
          return result;
        } catch (publishError) {
          setErrorMessage(getResultErrorMessage(publishError));
          return publishError;
        }
      }}
      onCancel={() => {
        closeDialog();
        setNewPublicState(dashboardLib?.activeDashboard?.State?.IsPublic ?? false);
        setErrorMessage("");
      }}
      okText="Publish"
      disableOk={!hasTitle || !isOnPublishedWorkspace}
    >
      <div className="dialog-text">
        {!hasTitle ? (
          <div style={{ whiteSpace: 'pre-wrap' }} className="error">
            The dashboard you want to publish is missing a title. Please return and add a title before publishing.
          </div>
        ) : !isOnPublishedWorkspace ? (
          <div style={{ whiteSpace: 'pre-wrap' }} className="error">
            Switch this dashboard to the current published model workspace before publishing.
          </div>
        ) : !errorMessage ? (
          <>
            Please confirm that you want to publish this dashboard.
            <div className="dialog-checkbox">
              <CheckboxControl
                value={newPublicState}
                onChange={() => setNewPublicState(!newPublicState)}
              />
              <span>Make this dashboard public</span>
            </div>
          </>
        ) : (
          <div style={{ whiteSpace: 'pre-wrap' }} className="error">
            {errorMessage}
          </div>
        )}
      </div>
    </DialogControl>
  );
};

export default PublishDialog;
